import { Search } from 'lucide-react';
import { TimerWidget } from '@/components/timer/TimerWidget';
import { NotificationsDropdown } from '@/components/notifications';
import { UserDropdown } from '@/components/user';

interface HeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

export function Header({ title, subtitle, actions }: HeaderProps) {
  return (
    <header className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{title}</h1>
          {subtitle && <div className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{subtitle}</div>}
        </div>

        <div className="flex items-center gap-4">
          {/* Timer Widget */}
          <TimerWidget />

          {/* Search */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 dark:text-gray-500" />
            <input
              type="text"
              placeholder="Search..."
              className="input pl-9 pr-4 py-2 w-64 text-sm"
            />
          </div>

          {/* Notifications */}
          <NotificationsDropdown />

          {/* User menu */}
          <UserDropdown />

          {/* Page actions */}
          {actions}
        </div>
      </div>
    </header>
  );
}
